module.exports = __webpack_public_path__ + "img/close.5821b30.svg";